import styles from './EmailSignaturePreview.module.scss';

import { usePageZoom } from '@work4all/data';

import { EMailSignature } from '@work4all/models/lib/Classes/EMailSignature.entity';

import { PreviewTitle, PreviewWrapper } from '../components';
import { setDefaultHeadStyles } from '../utils';

export type IEmailSignaturePreviewProps = {
  emailSignature: EMailSignature;
  onCloseClick?: React.MouseEventHandler<HTMLButtonElement>;
  onEditClicked?: React.MouseEventHandler<HTMLButtonElement>;
  onVisibilityToggle?: (visible: boolean) => void;
};

export function EmailSignaturePreview(props: IEmailSignaturePreviewProps) {
  const { emailSignature, onCloseClick, onEditClicked, onVisibilityToggle } =
    props;

  const { zoomLevel } = usePageZoom();

  return (
    <PreviewWrapper>
      <div className={styles.wrap}>
        <PreviewTitle
          onCloseClick={onCloseClick}
          onEditClicked={onEditClicked}
          onVisibilityToggle={onVisibilityToggle}
        >
          {emailSignature.name}
        </PreviewTitle>

        <iframe
          className={styles.content}
          title="Email signature Preview"
          srcDoc={
            setDefaultHeadStyles({
              value: emailSignature?.body || '',
              textmarkStyles: true,
              zoom: zoomLevel,
            }) || emailSignature.body
          }
        />
      </div>
    </PreviewWrapper>
  );
}
